// @flow
import React from 'react'
import I18n from 'i18n-react'
import { humanizer } from 'devx-js-utilities'

// types
type SelectedProductBarItemProps = {
  empty?: boolean,
  emptyText?: string,
  id: string,
  logo?: string,
  onClick?: () => void,
  onRemoveClick: (id: string) => void,
  price?: string,
  productName?: string,
  title?: string,
}

const defaultProps = {
  id: '',
  empty: false,
  emptyText: '',
  logo: '',
  onRemoveClick: () => {
  },
  price: '',
  productName: '',
  title: '',
}

const SelectedProductBarItem = (props: SelectedProductBarItemProps = defaultProps) => {

  const handleOnClick = () => {
    if (typeof props.onClick === 'function') {
      props.onClick()
    }
  }

  const handleOnRemoveClick = () => {
    props.onRemoveClick(props.id)
  }

  if (props.empty) {
    return (
      <div className='cart-item'>
        <div className='header'>
          <a className='text-dark' onClick={handleOnClick} style={{ textDecoration: 'none' }}>
            <span className='name'>{props.emptyText}</span>
          </a>
        </div>
      </div>
    )
  }

  return (
    <div className='cart-item selected'>
      <div className='header'>
        <strong className='name'>{props.productName}</strong>
        <a className='btn-link' onClick={handleOnRemoveClick}>
          <u className='d-sm-none d-lg-inline-block'>{I18n.translate('general.remove')}</u>
        </a>
      </div>
      <div className='info'>
        <div className='logo'>
          {!!props.logo && <img alt={props.title} className='d-sm-none d-lg-inline-block' src={props.logo} width={50}/>}
          <span className='label ml-2'>{props.title}</span>
        </div>
        {!!props.price &&
        <span className='value'>
            {humanizer.csNumber(props.price)}&nbsp;{I18n.translate('general.currency')}
          </span>
        }
      </div>
    </div>
  )
}

export default SelectedProductBarItem
